import { render } from "./SavePresetModal.vue?vue&type=template&id=05fe3274&scoped=true"
import script from "./SavePresetModal.vue?vue&type=script&lang=js"
export * from "./SavePresetModal.vue?vue&type=script&lang=js"

import "./SavePresetModal.vue?vue&type=style&index=0&id=05fe3274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fe3274"]])

export default __exports__